module.exports = __webpack_public_path__ + "static/media/hisense.77c60df2.png";